const getReferralUrl = () => {
  return document.referrer;
};

export default getReferralUrl;
